import React from 'react';
import { Anchor, Button, Chip, EditIcon, ListItemLayout, ListLayout } from '@keplerco/core';
import { ISummaryStepProps } from './summary-step.models';
import { useKeplerNavigate } from '../../../../navigation/guards/use-kepler-navigate';
import { PagePath } from '../../../../navigation/navigation.enums';
import { useAppState } from '../../../../overmind';
import { WidgetCard } from '../../../analytics/analytics-filters/widget-card';
import { EmptyState } from '../../../../components/general/empty-state/empty-state';
import { ReadOnlyField } from '../../../../components/wizard/read-only-field';

export default function SummaryStep({ skillCategory, goToStep, onBack }: ISummaryStepProps) {
  const keplerNavigate = useKeplerNavigate();

  const { companyVariables } = useAppState();

  return (
    <React.Fragment>
      <div style={{ width: '100%', display: 'flex', flexDirection: 'column', gap: 24 }}>
        <WidgetCard
          title="Details"
          button={
            // TODO: add steps to search params
            goToStep && (
              <Button fullWidthMobile type="button" square theme="background" onClick={() => goToStep(1)}>
                <div style={{ display: 'flex', gap: 4, alignItems: 'center' }}>
                  <EditIcon tone="text" />
                  Edit
                </div>
              </Button>
            )
          }
        >
          <ReadOnlyField name="Name">{skillCategory?.name}</ReadOnlyField>
          <ReadOnlyField name="Description">{skillCategory?.description || 'No description provided'}</ReadOnlyField>
          {skillCategory?.isArchived !== undefined && <ReadOnlyField name="Status">{skillCategory.isArchived ? <Chip>Archived</Chip> : <Chip themeColour="g">Active</Chip>}</ReadOnlyField>}
        </WidgetCard>

        <WidgetCard
          title="Skills"
          button={
            // TODO: add steps to search params
            goToStep && (
              <Button fullWidthMobile type="button" square theme="background" onClick={() => goToStep(2)}>
                <div style={{ display: 'flex', gap: 4, alignItems: 'center' }}>
                  <EditIcon tone="text" />
                  Edit
                </div>
              </Button>
            )
          }
        >
          {!!skillCategory?.skills.length ? (
            <div style={{ maxHeight: 400, overflowY: 'auto' }}>
              <ListLayout>
                {skillCategory.skills.map(skill => (
                  <ListItemLayout key={skill.slug}>
                    <div className="card">
                      <h5>{skill.name}</h5>

                      <div style={{ color: 'var(--text_1)' }}>{skill.description}</div>
                    </div>
                  </ListItemLayout>
                ))}
              </ListLayout>
            </div>
          ) : (
            <EmptyState />
          )}
        </WidgetCard>
      </div>

      {!!onBack && (
        <footer className="card" style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', background: 'var(--background)' }}>
          <Anchor arrow reverse onClick={onBack}>
            Back
          </Anchor>

          <div style={{ display: 'flex', alignItems: 'center', gap: 24 }}>
            <Button type="button" filled arrow onClick={() => keplerNavigate(`${PagePath.roleSkillManagementBase}${PagePath.roleSkillManagementSkillCategories.replace(':companySlug', companyVariables.slug!)}`)}>
              Save
            </Button>
          </div>
        </footer>
      )}
    </React.Fragment>
  );
}
